import * as React from 'react';
/**
 *
 * Original name: space almost full
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=4464%3A50
 *
 */
export const SpaceAlmostFullLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.975 12c0-.742.05-1.43.149-2.068l.755.125 6.204 1.03L9.894 4.13c.648-.103 1.35-.155 2.106-.155 5.4 0 8.025 2.625 8.025 8.025S17.4 20.025 12 20.025 3.975 17.4 3.975 12Zm7.681-6.468 1.26 7.38-7.384-1.227c-.003.104-.004.209-.004.315 0 4.476 1.996 6.472 6.472 6.472 4.476 0 6.472-1.996 6.472-6.472 0-4.476-1.996-6.472-6.472-6.472-.116 0-.23.002-.344.004Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M6.04 8.73c.5-1.292 1.375-2.173 2.66-2.679l-.267-1.57C6.44 5.146 5.126 6.47 4.469 8.47l1.57.26Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
